import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const SUPPORT_EMAIL = 'info@gainrhino.com';

// Non-dismissible payment warning shown to every user of an organization the
// Super Admin marked as past_due. Warning only — no feature restrictions.
const PaymentOverdueBanner = () => {
  const { organization } = useAuth();
  const billing = organization?.billing;

  if (billing?.status !== 'past_due') return null;

  const dueDate = billing.dueDate
    ? new Date(billing.dueDate).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      })
    : null;

  return (
    <div className="mt-4 mb-4 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-red-800">
      <div className="flex flex-wrap items-center gap-x-3 gap-y-2">
        <AlertTriangle size={20} className="flex-shrink-0 text-red-500" />
        <p className="flex-1 min-w-[240px] text-sm">
          <span className="font-semibold">Payment Overdue</span>
          {' — Your payment is overdue. Please settle your balance'}
          {dueDate && (
            <>
              {' by '}
              <span className="font-semibold">{dueDate}</span>
            </>
          )}
          {' to avoid service interruption.'}
          {billing.note && (
            <span className="block mt-1 text-red-700">Note: {billing.note}</span>
          )}
        </p>
        <a
          href={`mailto:${SUPPORT_EMAIL}`}
          className="flex-shrink-0 rounded-md bg-red-600 px-3 py-1.5 text-sm font-medium text-white hover:bg-red-700 transition-colors"
        >
          Contact us
        </a>
      </div>
    </div>
  );
};

export default PaymentOverdueBanner;
